"use strict";
/**
 * {@code ProximityBase} is the base class for any concrete proximity based on an iterable collection of agents.
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var ProximityBase = (function () {
    /**
     * Creates a {@code ProximityBase} for the specified owner and list of agents.
     * @param owner the owner of this proximity
     * @param agents the list of agents
     */
    function ProximityBase(owner, agents) {
        this.owner = owner;
        this.agents = agents;
    }
    ProximityBase.prototype.getOwner = function () {
        return this.owner;
    };
    ProximityBase.prototype.setOwner = function (owner) {
        this.owner = owner;
    };
    /** Returns the the agents that represent potential neighbors. */
    ProximityBase.prototype.getAgents = function () {
        return this.agents;
    };
    /** Sets the agents that represent potential neighbors. */
    ProximityBase.prototype.setAgents = function (agents) {
        this.agents = agents;
    };
    return ProximityBase;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProximityBase;
//# sourceMappingURL=ProximityBase.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/steer/proximities/ProximityBase.js
 ** module id = 896
 ** module chunks = 0
 **/